import routerOptions0 from "/app/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "auto",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}